import { HeaderFields, HeaderProps, TCountryFields } from '../types/navigationItem.types';
import { newNavigationItemModel, TNavigationItemModel } from './navigationItem.model';
import { TIconField, TLinkField, TStringField } from '../../../types/sitecore.types';

export class CountrySelectorModel {
  private readonly _fields: TCountryFields;
  public readonly icon?: TIconField;
  public readonly title: TStringField;
  public readonly link: TLinkField;

  constructor(fields: TCountryFields) {
    this._fields = fields || {};

    this.icon = this._fields?.icon;
    this.title = this._fields?.title ?? { value: '' };
    this.link = this._fields?.link ?? { value: { href: '#' } };
  }
}

export class HeaderModel {
  public readonly fields: HeaderFields;
  public readonly navigationItemModelsArr: TNavigationItemModel[];
  public readonly mobileTitle: TStringField;
  public readonly mobileTitleOpen: TStringField;
  public readonly countrySelector: CountrySelectorModel;
  public readonly isUnreleased: boolean;

  constructor(props: HeaderProps) {
    this.fields = props?.fields || {};
    if (this.fields?.primaryHeaderMenuLinks && Array.isArray(this.fields?.primaryHeaderMenuLinks)) {
      this.navigationItemModelsArr = this.fields?.primaryHeaderMenuLinks?.map((navigationItemData) =>
        newNavigationItemModel(navigationItemData?.fields, (navigationItemData?.id ?? ''), navigationItemData?.displayName)
      );
    }
    this.mobileTitle = this.fields?.mobileTitle || { value: '' };
    this.mobileTitleOpen = this.fields?.mobileTitleOpen || { value: '' };
    this.countrySelector = new CountrySelectorModel(this.fields?.country);
    this.isUnreleased = this.fields?.isComponentUnreleased || false;
  }
}
